<template>
  <div
    v-if="shown"
    class="policy-modal"
    :class="{ 'is-active': isSpecialist && !isPolicyConfirmed}"
  >
    <div
      class="policy-modal__backdrop"
    />

    <div class="policy-modal__inner">
      <div class="input-block">
        <label class="group-item-checkbox group-item-checkbox--blue-checkbox-border">
          <input
            v-model="checkbox"
            type="checkbox"
          >
          <span />
          <p>
            Подтверждаю
            <a
              href="/specialist-policy/"
              target="_blank"
              class="policy-modal__link"
            >
              согласие на обработку персональных данных
            </a>
          </p>

        </label>
      </div>
      <button
        type="submit"
        class="button button--primary policy-modal__submit"
        :disabled="isButtonDisabled"
        @click="submit"
      >
        Согласен
      </button>
    </div>
  </div>
</template>

<script>
import requests from '../../utils/requests';

export default {
  name: 'PolicyConfirmModal',

  data() {
    return {
      isPolicyConfirmed : true,
      checkbox          : false,
      isSpecialist      : false,
      shown             : true
    };
  },
  computed: {
    // ...mapState('MyProfile', ['currentData']),
    isButtonDisabled() {
      if (this.checkbox) {
        return false;
      }
      return true;
    }
  },
  mounted() {
    this.getPersonalData();
    this.getSpecialistPolicy();
    // this.getPolicyConfirm();
  },
  methods: {
    close() {
      this.shown = false;
    },
    submit() {
      this.setSpecialistPolicy();
    },
    getSpecialistPolicy() {
      requests.getData('/api/v1/agreement/healthcare-professional-personal-data/status/').then((data) => {
        this.isPolicyConfirmed = data.data;
      });
    },
    async setSpecialistPolicy() {
      try {
        const response = await fetch('/api/v1/agreement/healthcare-professional-personal-data/consent/', {
          method: 'POST'
        });
        await response.json();
        this.close();
      } catch (error) {
        console.error('Ошибка:', error);
      }
    },
    getPersonalData() {
      if ('memoFetch' in window) {
        window.memoFetch('/api/v2/internal/consumer/info/', true)
          .then((data) => {
            if (data.data) {
              this.isSpecialist = data.data.user.isSpecialist;
            }
          });
      } else {
        requests.getData('/api/v2/internal/consumer/info/')
          .then((data) => {
            if (data.data) {
              this.isSpecialist = data.data.user.isSpecialist;
            }
          });
      }
    }
  }
};
</script>


<style lang="scss">
@import "../../../css/utils/variables";
@import "../../../css/utils/button-clean";
@import "../../../css/utils/typography";
@import "../../../css/utils/grid";
@import "../../../css/utils/button-primary-disabled";

.policy-modal__link{
    color: #003595;
    text-decoration: none;
    cursor: pointer;
}

.policy-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: rgba($color-black, .5);
  z-index: 10000;
  display: flex;
  justify-content: center;
  transition: opacity .2s;
  @include media-breakpoint-down(xs) {
    background-color: $color-white;
    display: block;
    top: 64px;
  }

  &:not(.is-active) {
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
  }

  &__backdrop {
    position: absolute;
    left: 0;
    top: 0;

    width: 100%;
    height: 100%;

    cursor: pointer;

    @include media-breakpoint-down(xs) {
      display: none;
    }
  }

  &__inner {
    background-color: $color-white;
    box-shadow: 0 2px 14px rgba($color-black, .17);
    max-width: 530px;
    width: 100%;
    box-sizing: border-box;
    padding: 72px;
    margin: auto;
    position: relative;
    @include media-breakpoint-down(xs) {
      box-shadow: none;
      padding: 32px 20px;
      margin: 0 auto;
    }
  }
  &__input-wrap {
    margin-bottom: 32px;
  }
  &:invalid &__submit {
    @include button-primary-disabled;
  }
  &__submit.button {
    width: 100%;
    text-align: center;
    margin-bottom: 32px;
    display: block;
  }
}
</style>
